// src/App.tsx
import React from "react";
import AppRouter from "./routes/AppRouter";
import PageContainer from "./components/layout/PageContainer";

export default function App() {
  return (
    <PageContainer>
      <AppRouter />
    </PageContainer>
  );
}
